/**
 * Parses a backend timestamp into a Date. If the string has no timezone
 * offset (Laravel pivot columns often serialize as naive "Y-m-d H:i:s"),
 * it is treated as UTC rather than local — otherwise the browser's default
 * `Date` parsing would silently shift the moment by the local UTC offset
 * (e.g. showing a Perth user's leave_at 8 hours early).
 *
 * Mirrors tradiepass-flutter's lib/utility/date_helper.dart parseServerDate,
 * which defends against the same naive-timestamp hazard on mobile.
 */
export function parseServerDate(s) {
  if (!s) return null
  const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/.test(s)
  const iso = s.replace(' ', 'T') + (hasOffset ? '' : 'Z')
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? null : d
}
